import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { getListKunjunganByGroup } from "stores";
import { showUrlDokumenKunjungan } from "stores";
import { ColorRing, Dna, Watch } from "react-loader-spinner";
import { showUrlBuktiKunjungan } from "stores";
import GoogleMapReact from "google-map-react";

function ListKunjunganByGroup(data) {
  //   console.log(data, "DATAA");
  const dispatch = useDispatch();
  const korcab = useSelector((state) => state.korcabReducer);
  const urlPreview = korcab.urlDokumenKunjungan;
  const handleClick = () => {
    dispatch({ type: "SET_KUNJUNGAN_BY_GROUP", data: true });
  };
  // console.log(korcab, "KORCAB");
  const [listKunjunganPerGroup, setListKunjunganPerGroup] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  //   const [searchText, setSearchText] = React.useState("");
  const [modalDetails, setModalDetails] = React.useState(false);
  const [detailKunjungan, setDetailKunjungan] = React.useState([]);
  const [buktiKunjungan, setBuktiKunjungan] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };
  const formatRupiah = (angka) => {
    const numberFormat = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    });
    return numberFormat.format(angka);
  };

  const handleClickKunjungan = (val) => {
    setModalDetails(!modalDetails);
    setDetailKunjungan(val);
    setLoading(true); // Mulai loading
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    setBuktiKunjungan(
      showUrlDokumenKunjungan(dispatch, {
        urlImage: val.buktiKunjungan,
      }),
    );
    setLatitude(parseFloat(val.lat));
    setLongitude(parseFloat(val.long));
  };

  React.useEffect(() => {
    if (korcab.listDataKunjunganByGroup.docs) {
      let tmp = korcab.listDataKunjunganByGroup.docs.map((val) => {
        return {
          ...val,
          action: (
            <div className="d-flex justify-content-center align-items-center">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-visit-${val._id}`}>
                    Detail Kunjungan
                  </Tooltip>
                }
              >
                <Button
                  className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    backgroundColor: "#ECFEFF", // Light Cyan (Sangat Segar)
                    border: "1px solid #CFFAFE",
                    color: "#0891B2", // Cyan Dark
                    transition: "all 0.2s ease",
                    marginTop: 5,
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#0891B2";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#ECFEFF";
                    e.currentTarget.style.color = "#0891B2";
                  }}
                  onClick={() => handleClickKunjungan(val)}
                >
                  <i className="fas fa-eye" style={{ fontSize: "14px" }}></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
      setListKunjunganPerGroup(tmp);
    }
  }, [korcab.listDataKunjunganByGroup]);

  const AnyReactComponent = ({ text }) => (
    <div style={{ color: "red", fontWeight: "bold" }}>
      <i className="fas fa-map-marker-alt"></i> {text}
    </div>
  );

  const DetailItem = ({ label, value, col = 12, color = "black" }) => (
    <Col md={col} className="mb-3">
      <label
        className="text-muted small fw-bold uppercase d-block mb-1"
        style={{ fontSize: "10px" }}
      >
        {label}
      </label>
      <div className="fw-800" style={{ color: color, fontSize: "14px" }}>
        {value || "-"}
      </div>
    </Col>
  );

  const BadgeStatus = ({ type, value }) => {
    let colors = { bg: "#eee", text: "#333" };

    if (type === "keputusan") {
      if (value === "Disetujui") colors = { bg: "#ECFDF5", text: "#059669" };
      if (value === "Tunda") colors = { bg: "#FFF7ED", text: "#EA580C" };
      if (value === "Batal") colors = { bg: "#FEF2F2", text: "#DC2626" };
    } else {
      if (value === "Pinjam") colors = { bg: "#EFF6FF", text: "#2563EB" };
      if (value === "Perhitungan Minus")
        colors = { bg: "#F5F3FF", text: "#7C3AED" };
    }

    return (
      <div
        className="text-center py-1 px-2 rounded fw-800"
        style={{
          backgroundColor: colors.bg,
          color: colors.text,
          fontSize: "11px",
        }}
      >
        {value || "-"}
      </div>
    );
  };

  const defaultProps = {
    center: {
      lat: 0,
      lng: 0,
    },
    zoom: 11,
  };

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getStatusStyle = (status) => {
    switch (status) {
      case "Progress":
        return {
          fontWeight: "bold",
          backgroundColor: "#FDE5DD",
          textColor: "#F85317",
        };
      case "Done":
        return {
          fontWeight: "bold",
          backgroundColor: "#BAD9FD",
          textColor: "#1776F1",
        };
      default:
        return {};
    }
  };

  const getKeputusan = (keputusan) => {
    switch (keputusan) {
      case "Tunda":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE6CC",
          textColor: "#FF7F00",
        };
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Disetujui":
        return {
          fontWeight: "bold",
          backgroundColor: "#E4F5C9",
          textColor: "#87CB16",
        };
      case "Ditolak":
        return {
          fontWeight: "bold",
          backgroundColor: "#FF0000",
          textColor: "#FFE6E6",
        };
      default:
        return {};
    }
  };

  const getHasil = (hasilNasabah) => {
    switch (hasilNasabah) {
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Pinjam":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      case "Perhitungan Minus":
        return {
          fontWeight: "bold",
          backgroundColor: "#F2E6FF",
          textColor: "#7F00FF",
        };
      case "-":
        return {
          fontWeight: "bold",
          textColor: "#000000",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F8FAFC",
        minHeight: "50px",
        borderTop: "1px solid #E2E8F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "11px",
        color: "#64748B",
        textTransform: "uppercase",
        justifyContent: "center",
      },
    },
    rows: {
      style: {
        minHeight: "65px",
        "&:hover": {
          backgroundColor: "#F1F5F9",
          cursor: "pointer",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "12.5px",
        justifyContent: "center",
        color: "#334155",
      },
    },
  };

  const colGroupKunjungan = [
    {
      name: "NO",
      width: "60px",
      center: true,
      selector: (row, index) => index + korcab.groupKujunganById.pagingCounter,
      style: { fontWeight: "bold", color: "#94A3B8" },
    },
    {
      name: "IDENTITAS KUNJUNGAN",
      minWidth: "220px",
      cell: (row) => (
        <div className="py-2 text-center">
          <div className="fw-800 text-primary" style={{ fontSize: "13px" }}>
            {row.idGroupKunjungan}
          </div>
          <div className="small text-muted mt-1">
            <i className="far fa-calendar-alt mr-1"></i>
            {moment(row.tglKunjungan).format("DD MMM YYYY")}
          </div>
        </div>
      ),
    },
    {
      name: "ID LOAN",
      minWidth: "140px",
      center: true,
      cell: (row) => (
        <span className="badge bg-light text-dark border">
          {row.id_pinjaman || "-"}
        </span>
      ),
    },
    {
      name: "UNIT / CABANG",
      minWidth: "180px",
      cell: (row) => (
        <div className="fw-600 text-center">
          {row.cabang?.namaCabang || "-"}
        </div>
      ),
    },
    {
      name: "TIM MANAJEMEN",
      minWidth: "250px",
      cell: (row) => (
        <div
          className="text-center"
          style={{ fontSize: "11.5px", lineHeight: "1.4" }}
        >
          <div>
            <span className="text-muted">AM:</span>{" "}
            <strong>{row.areaManager?.nama || "-"}</strong>
          </div>
          <div>
            <span className="text-muted">SV:</span>{" "}
            <strong>{row.supervisor?.nama || "-"}</strong>
          </div>
          <div>
            <span className="text-muted">MKT:</span>{" "}
            <strong>{row.marketing?.nama || "-"}</strong>
          </div>
        </div>
      ),
    },
    {
      name: "NETT",
      minWidth: "150px",
      center: true,
      cell: (row) => (
        <span className="fw-800 text-dark">
          {new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
          }).format(row.nett)}
        </span>
      ),
    },
    {
      name: "KEPUTUSAN & HASIL",
      minWidth: "220px",
      center: true,
      cell: (row) => {
        const kepStyle = getKeputusan(row.keputusan);
        const hasil =
          row.hasil === "Perhitungan minus"
            ? "Perhitungan Minus"
            : row.hasil || "-";
        const hasilStyle = getHasil(hasil);

        return (
          <div
            className="d-flex flex-column align-items-center py-2"
            style={{ gap: "4px" }}
          >
            <span
              style={{
                backgroundColor: kepStyle.backgroundColor,
                color: kepStyle.textColor,
                fontSize: "10px",
                fontWeight: "800",
                padding: "4px 10px",
                borderRadius: "5px",
                width: "100%",
                textAlign: "center",
              }}
            >
              {row.keputusan}
            </span>
            <span
              style={{
                backgroundColor: hasilStyle.backgroundColor,
                color: hasilStyle.textColor,
                fontSize: "10px",
                fontWeight: "800",
                padding: "4px 10px",
                borderRadius: "5px",
                width: "100%",
                textAlign: "center",
              }}
            >
              {hasil}
            </span>
          </div>
        );
      },
    },
    {
      name: "AKSI",
      width: "80px",
      center: true,
      cell: (row) => (
        <div className="d-flex justify-content-center">{row.action}</div>
      ),
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getListKunjunganByGroup(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      idGroup: data.data,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);
  return (
    <>
      <Modal
        size="xl"
        show={modalDetails}
        onHide={() => setModalDetails(false)}
        centered
        className="modal-modern"
      >
        <Modal.Header closeButton className="border-0 pb-0" />
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <h4
              className="fw-800 text-dark uppercase mb-0"
              style={{ fontWeight: 700 }}
            >
              Laporan Detail Kunjungan
            </h4>
            <div
              className="mx-auto mt-2"
              style={{
                width: "60px",
                height: "4px",
                backgroundColor: "#F75D59",
                borderRadius: "10px",
              }}
            ></div>
          </div>

          <Row>
            {/* KIRI: Informasi Data */}
            <Col lg={7}>
              <Card
                className="border-0 bg-light shadow-none mb-3"
                style={{ borderRadius: "15px" }}
              >
                <Card.Body className="p-4">
                  <h6 className="fw-800 text-primary mb-3 small uppercase">
                    <i className="fas fa-file-alt mr-2"></i> Data Kunjungan
                  </h6>
                  <Row>
                    <DetailItem
                      label="Tanggal"
                      value={moment(detailKunjungan.tglKunjungan).format(
                        "DD MMMM YYYY",
                      )}
                      col={6}
                    />
                    <DetailItem
                      label="Wilayah"
                      value={detailKunjungan.wilayah?.namaWilayah}
                      col={6}
                    />

                    <DetailItem
                      label="Plafond"
                      value={formatRupiah(detailKunjungan.plafond)}
                      color="#1D3557"
                      col={6}
                    />
                    <DetailItem
                      label="Nett"
                      value={formatRupiah(detailKunjungan.nett)}
                      color="#116D6E"
                      col={6}
                    />

                    <Col md={6} className="mb-3">
                      <label className="text-muted small fw-bold uppercase d-block mb-1">
                        Keputusan
                      </label>
                      <BadgeStatus
                        type="keputusan"
                        value={detailKunjungan.keputusan}
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <label className="text-muted small fw-bold uppercase d-block mb-1">
                        Hasil
                      </label>
                      <BadgeStatus type="hasil" value={detailKunjungan.hasil} />
                    </Col>
                  </Row>

                  <hr className="my-3" />

                  <h6 className="fw-800 text-primary mb-3 small uppercase">
                    <i className="fas fa-sitemap mr-2"></i> Hierarki Manajemen
                  </h6>
                  <Row>
                    <DetailItem
                      label="Area Manager"
                      value={detailKunjungan.areaManager?.nama}
                      col={6}
                    />
                    <DetailItem
                      label="Supervisor"
                      value={detailKunjungan.supervisor?.nama}
                      col={6}
                    />
                    <DetailItem
                      label="Marketing"
                      value={detailKunjungan.marketing?.nama}
                      col={6}
                    />
                    <DetailItem
                      label="Koor. Cabang"
                      value={detailKunjungan.korcab?.nama}
                      col={6}
                    />
                  </Row>

                  <div className="mt-3 p-3 bg-white rounded border">
                    <label className="text-muted small fw-bold uppercase d-block mb-1">
                      Keterangan
                    </label>
                    <p className="mb-0 text-dark fw-600 small">
                      {detailKunjungan.keterangan || "-"}
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* KANAN: Foto & Map */}
            <Col lg={5}>
              <h6 className="fw-800 text-primary mb-3 small uppercase">
                <i className="fas fa-camera mr-2"></i> Bukti Foto
              </h6>
              <div
                className="photo-container mb-4 rounded border d-flex align-items-center justify-content-center bg-white shadow-sm overflow-hidden"
                style={{ height: "250px" }}
              >
                {buktiKunjungan ? (
                  loading ? (
                    <ColorRing height="60" width="60" />
                  ) : (
                    <img
                      src={urlPreview}
                      className="img-fluid"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  )
                ) : (
                  <div className="text-center p-3">
                    <img
                      src={require("assets/img/sorry.jpg").default}
                      style={{ width: "80px", borderRadius: "10px" }}
                    />
                    <p className="mt-2 text-muted small fw-bold">
                      Belum ada foto bukti
                    </p>
                  </div>
                )}
              </div>

              <h6 className="fw-800 text-primary mb-3 small uppercase">
                <i className="fas fa-map-marked-alt mr-2"></i> Titik Lokasi
              </h6>
              <div
                className="map-container rounded border shadow-sm overflow-hidden"
                style={{ height: "250px" }}
              >
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: "AIzaSyDEQbFkmNjBsVFEHW_pLszpxLNOXr5HLYk",
                  }}
                  center={{
                    lat: latitude || -0.4948,
                    lng: longitude || 117.1355,
                  }}
                  defaultZoom={15}
                >
                  {latitude && longitude && (
                    <AnyReactComponent lat={latitude} lng={longitude} />
                  )}
                </GoogleMapReact>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Container fluid className="py-4">
        <Button
          variant="white"
          className="btn-icon shadow-sm mb-4 border d-flex align-items-center justify-content-center"
          style={{
            width: "45px",
            height: "45px",
            borderRadius: "12px",
            color: "#F75D59",
          }}
          onClick={handleClick}
        >
          <i className="fas fa-arrow-left"></i>
        </Button>

        <Card className="border-0 shadow-sm rounded-xl">
          <Card.Header className="bg-white border-0 pt-4 px-4">
            <h3 className="fw-800 text-dark text-center uppercase mb-0">
              Kunjungan Per Group
            </h3>
            <p className="text-muted small text-center">
              Daftar rincian aktivitas kunjungan dalam satu grup.
            </p>
            <hr className="mt-3" />
          </Card.Header>

          <Card.Body className="px-4 pb-4">
            {isLoading ? (
              <div className="py-5 text-center">
                <Watch height="60" width="60" color="#F75D59" />
                <h5 className="mt-3 text-muted">Menyusun Data...</h5>
              </div>
            ) : (
              <div className="table-responsive-custom">
                {listKunjunganPerGroup.length > 0 ? (
                  <>
                    <DataTable
                      columns={colGroupKunjungan}
                      data={listKunjunganPerGroup}
                      customStyles={customStyles}
                      pagination={false}
                      highlightOnHover
                    />
                    {/* Pagination Footer - Gunakan komponen footer yang kita buat sebelumnya */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 pt-4 border-top">
                      <div className="d-flex align-items-center mb-3 mb-md-0">
                        <span className="text-muted small fw-bold mr-3">
                          Tampilkan
                        </span>
                        <div style={{ width: "100px" }}>
                          <Select
                            options={options}
                            value={options.find(
                              (o) => o.value === totalPerHalaman,
                            )}
                            onChange={handlePageSizeChange}
                          />
                        </div>
                      </div>
                      <ReactPaginate
                      // Properti ReactPaginate yang sudah kita standarisasi sebelumnya
                      />
                    </div>
                  </>
                ) : (
                  <div className="text-center py-5">
                    <img
                      src={require("assets/img/sorry.jpg").default}
                      style={{ maxWidth: "180px" }}
                    />
                    <p className="mt-3 fw-bold text-muted">
                      Maaf, data kunjungan belum tersedia.
                    </p>
                  </div>
                )}
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default ListKunjunganByGroup;
